import React, { useState } from "react";
import { useLang } from "@/context/LanguageContext";

// Overlays the "before" image (client photo) on top of the "after" image
// (registry photo) with a draggable reveal handle for fine comparison.
export function BeforeAfterSlider({ before, after, beforeLabel = "Client", afterLabel = "Registre" }) {
  const { t } = useLang();
  const [pos, setPos] = useState(50);
  return (
    <div className="select-none" data-testid="before-after">
      <div className="relative w-full h-64 rounded-xl overflow-hidden border border-border bg-slate-100">
        <img src={after} alt={afterLabel} className="absolute inset-0 w-full h-full object-contain bg-slate-100" draggable={false} />
        <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={before} alt={beforeLabel} className="absolute inset-0 w-full h-full object-contain bg-slate-100" draggable={false} />
        </div>
        <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(0,0,0,.25)]" style={{ left: `${pos}%` }}>
          <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-7 w-7 grid place-items-center rounded-full bg-white text-findo-indigo shadow text-xs font-bold">↔</span>
        </div>
        <span className="absolute top-2 left-2 text-[11px] font-semibold text-white bg-black/55 px-1.5 py-0.5 rounded">{beforeLabel}</span>
        <span className="absolute top-2 right-2 text-[11px] font-semibold text-white bg-black/55 px-1.5 py-0.5 rounded">{afterLabel}</span>
      </div>
      <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(+e.target.value)}
        className="w-full mt-2 accent-findo-indigo cursor-pointer" data-testid="before-after-range"
        aria-label={t("hc.beforeAfterComparisonSlider")} />
    </div>
  );
}
